import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';

import { InfiniteScrollModule } from 'presentation/common/directive/infinite-scroll/infinite-scroll.module';
import { PipeModule } from 'presentation/common/pipe/pipe.module';

import { AppPrimengModule } from '../../../../../app-primeng.module';
import { AppSharedModule } from '../../../../../app-shared.module';
import { CoacheeProfileDocumentsDocumentComponent } from './coachee-profile-documents-document/coachee-profile-documents-document.component';
import { CoacheeProfileDocumentsFilterComponent } from './coachee-profile-documents-filter/coachee-profile-documents-filter.component';
import { CoacheeProfileDocumentsHeaderComponent } from './coachee-profile-documents-header/coachee-profile-documents-header.component';
import { CoacheeProfileDocumentsComponent } from './coachee-profile-documents.component';

@NgModule({
	declarations: [
		CoacheeProfileDocumentsComponent,
		CoacheeProfileDocumentsDocumentComponent,
		CoacheeProfileDocumentsFilterComponent,
		CoacheeProfileDocumentsHeaderComponent,
	],
	imports: [
		TableModule,
		DropdownModule,
		CalendarModule,
		InputTextModule,
		ReactiveFormsModule,
		CommonModule,
		TranslateModule,
		PipeModule,
		MultiSelectModule,
		AppPrimengModule,
		AppSharedModule,
		InfiniteScrollModule,
	],
	exports: [CoacheeProfileDocumentsComponent],
	providers: [],
})
export class CoacheeProfileDocumentsModule {}
